<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'設問セット：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'設問セット：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addQuestSet()" [disabled]="!formGroup.valid || !quest_set!.questions.length">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="auto" style="overflow: auto;">
    <form class="form" [formGroup]="formGroup">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">
        <mat-form-field *ngIf="!isAdded" fxFlex="100%">
          <mat-label floatLabel="always">ID</mat-label>
          <input matInput placeholder="ID" id="id" formControlName="id" readonly>
        </mat-form-field>
        <mat-form-field fxFlex="100%">
          <mat-label floatLabel="always">{{'表示タイトル' | translate}}</mat-label>
          <input matInput placeholder="{{'表示タイトル' | translate}}" id="questionTitles"
            value="{{ quest_set!.question_titles | multiStringMessage:projectLanguages:projectBaseLang }}" readonly>
          <button matSuffix mat-stroked-button color="primary" (click)="openQuestionTitleDialog()">
            <mat-icon>edit</mat-icon>
          </button>
          <mat-error *ngIf="questionTitlesControl.invalid">{{ getErrorMessageToQuestionTitle() }}</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="100%">
          <mat-label floatLabel="always">{{'管理名称' | translate}}</mat-label>
          <input matInput placeholder="{{'管理名称' | translate}}" id="name" formControlName="name">
        </mat-form-field>
        <mat-form-field fxFlex="100%">
          <mat-label floatLabel="always">{{'表示順' | translate}}</mat-label>
          <input matInput placeholder="{{'表示順' | translate}}" id="dispOrder" formControlName="dispOrder">
          <mat-error *ngIf="dispOrderControl.invalid">{{ getErrorMessageToDispOrder() }}</mat-error>
        </mat-form-field>
        <mat-checkbox color="primary" formControlName="useQuestion">{{'アンケートを表示する' | translate}}</mat-checkbox>

        <div class="floor-list">
          <div class="floor-list-title" fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{'設問リスト（' | translate}} {{ !!quest_set && !!quest_set.questions ? quest_set.questions.length:0 }}
              {{'件）' | translate}}</span>
            <button mat-stroked-button (click)="openSelectQuestionsDialog()" [disabled]="useQuestionControl.value">
              <mat-icon>add</mat-icon>
              <span>{{'設問リスト追加' | translate}}</span>
            </button>
          </div>

          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>{{'設問' | translate}}</th>
                <th>{{'設問タイプ' | translate}}</th>
                <!-- <th>{{'フロア・表示グループ' | translate}}</th> -->
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropQuestion($event)">
              <tr *ngFor="let question of quest_set?.questions" cdkDrag cdkDragLockAxis="y">
                <td>{{ question.question_id }}</td>
                <td>{{ question.question_names | multiName:projectLanguages:projectBaseLang }}</td>
                <td>{{ question.question_type }}</td>
                <!-- <td>
                  <span *ngFor="let hall of (floor.hall_id | docsByCond:hallsCollectionName:'hall_id' | async)">
                    {{ hall.hall_names | multiName:projectLanguages:projectBaseLang }}
                  </span>
                </td> -->
                <!-- <td>{{ floor.floor_names | multiName:projectLanguages:projectBaseLang }}</td> -->
                <td>
                  <button mat-stroked-button color="warn" (click)="deleteQuestion(question.question_id!)"
                    [disabled]="useQuestionControl.value">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="facility-files">
          <div class="facility-files-title" fxLayout="row" fxLayoutAlign="space-between end">
            <span>{{'プレゼント用画像ファイル' | translate}}</span>
            <button mat-stroked-button (click)="openSelectFilesDialog()">
              <mat-icon>add</mat-icon>
              <span>{{'ファイル追加' | translate}}</span>
            </button>
          </div>
          <span class="supplement">{{'※プレゼント用画像ファイルを登録します。言語ごとの登録が可能です。登録した画像はアンケート終了後にダウンロードすることができます。' |
            translate}}</span><br>
          <span class="supplement">&nbsp;{{'（施設情報：編集の「アンケート終了時にありがとうページを表示する」が有効であることが前提）' | translate}}</span>

          <table>
            <thead>
              <tr>
                <th>{{'画像' | translate}}</th>
                <th>{{'名称' | translate}}</th>
                <th style="width: 100px;">{{'言語' | translate}}</th>
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropFile($event)">
              <tr *ngFor="let dlFile of dlFiles; let i=index" cdkDrag cdkDragLockAxis="y">
                <td><img [src]="dlFile.download_url" height="40px" width="auto"></td>
                <td>{{ dlFile.file_name }}</td>
                <td>
                  <mat-select id="lang" [value]="dlFile.lang_code" (selectionChange)="changeDLFileLang(i, $event)">
                    <ng-container *ngFor="let language of projectLanguages">
                      <mat-option [value]="language.lang_code">
                        {{ currentLang === 'ja' ? language.lang_name : language.lang_name_en }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </td>
                <td>
                  <button mat-stroked-button color="warn" (click)="deleteFiles(i)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <table>
          <thead>
            <tr>
              <th width="70px">{{'ID' | translate}}</th>
              <th>{{'設問名' | translate}}</th>
              <th width="120px">{{'設問タイプ' | translate}}</th>
              <th width="80px" style="text-align:right">{{'選択肢' | translate}}</th>
            </tr>
          </thead>
          <tbody class="cdk-table">
            <tr *ngFor="let question of quest_set!.questions; let i = index">
              <td width="70px">
                {{ question.question_id }}
              </td>
              <td>
                {{ question.question_names | multiQname:projectLanguages:projectBaseLang }}
              </td>
              <td width="120px">
                {{ question.question_type }}
              </td>
              <td width="80px" style="text-align:right">
                <span
                  *ngIf="question.question_type != 'select' && question.question_type != 'checkbox' && question.question_type != 'radio'">
                  ー ー </span>
                <span
                  *ngIf="question.question_type == 'select' || question.question_type == 'checkbox' || question.question_type == 'radio'">{{
                  question.question_select_items.length }} {{'件' | translate}}</span>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </form>
  </div>


</div>